export default "#containerPanierList {\n  /*max-height: 85vh;*/\n  width: 96%;\n  overflow-y: auto;\n  position: relative;\n}"